export default {
  data() {
    return {
      exportSendOutsExcelFields: [
        {
          label: "Accession ID",
          value: "accession_id",
        },
        {
          label: "Case Type",
          value: "case_types",
        },
        {
          label: "Collection Date",
          value: "collection_date",
        },
        {
          label: "Ordering Facility",
          value: "hospital.name",
        },
        {
          label: "Ordering Physician",
          value: "ordering_physician.name",
        },
        {
          label: "Physician NPI",
          value: "ordering_physician.npi_code",
        },
        {
          label: "Patient First Name",
          value: "patient_info.first_name",
        },
        {
          label: "Patient Last Name",
          value: "patient_info.last_name",
        },
        {
          label: "Patient DOB",
          value: "patient_info.date_of_birth",
        },
        {
          label: "Received Date",
          value: "received_date",
        },
        {
          label: "Received Lab",
          value: "received_lab",
        },
      ],
      defaultExportSendOutsExcelFields: [
        {
          label: "Collection Date",
          value: "collection_date",
        },
        {
          label: "Accession ID",
          value: "accession_id",
        },
        {
          label: "Patient First Name",
          value: "patient_info.first_name",
        },
        {
          label: "Patient Last Name",
          value: "patient_info.last_name",
        },
        {
          label: "Patient DOB",
          value: "patient_info.date_of_birth",
        },
        {
          label: "Case Type",
          value: "case_types",
        },
        {
          label: "Ordering Facility",
          value: "hospital.name",
        },
        {
          label: "Ordering Physician",
          value: "ordering_physician.name",
        },
        {
          label: "Physician NPI",
          value: "ordering_physician.npi_code",
        },
        {
          label: "Received Date",
          value: "received_date",
        },
        {
          label: "Received Lab",
          value: "received_lab",
        },
      ],
    }
  },
}
